import React, { useContext, useState, useEffect } from "react";
import classnames from "classnames";
import ResetState from "./resetstate";
import Responsive from "./responsive";
import { GrigoraEditorContext } from "../editor/context";
function NumberInput({
  value,
  onChange,
  step = 1,
  min = 0,
  max = 100,
  unit = "px",
  label = "",
  resetValue,
  className,
  isResetVisible = true,
  hideResetSlot = false,
  isResponsive = false,
  valueTablet,
  setValueTablet,
  resetValueTablet,
  valueMobile,
  setValueMobile,
  resetValueMobile,
}) {
  const [active, setActive] = useState("desktop");
  const editorContext = useContext(GrigoraEditorContext);

  useEffect(() => {
    if (editorContext?.displaySize && isResponsive) {
      setActive(editorContext.displaySize);
    }
  }, [editorContext?.displaySize]);

  value = Number(value);
  valueMobile = Number(valueMobile);
  valueTablet = Number(valueTablet);
  step = Number(step);

  if (isNaN(value)) {
    value = resetValue;
  }
  if (isNaN(valueMobile)) {
    valueMobile = resetValueMobile;
  }
  if (isNaN(valueTablet)) {
    valueTablet = resetValueTablet;
  }

  if (value === undefined || value === null) {
    value = "";
  }
  if (valueMobile === undefined || valueMobile === null) {
    valueMobile = "";
  }
  if (valueTablet === undefined || valueTablet === null) {
    valueTablet = "";
  }

  const classes = classnames(
    "grigora-range-input relative right-0 text-grigora-base flex items-center justify-between mb-2",
    className,
  );

  return (
    <div className={classes}>
      {label && (
        <span className="grigora-select-input__label flex flex-1 select-none  items-center">
          {label}
          {/* {isResponsive && (
            <div className="relative ">
              <Responsive
                activeMode={active}
                onChangeActiveMode={(e) => setActive(e)}
              />
            </div>
          )} */}
        </span>
      )}
      <div className="flex gap-[5px] justify-center items-center">
        {!hideResetSlot && (
          <ResetState
            active={
              isResetVisible &&
              ((value !== resetValue && value != "") ||
                (valueTablet !== resetValueTablet && valueTablet != "") ||
                (valueMobile !== resetValueMobile && valueMobile != ""))
            }
            onClick={() => {
              onChange(resetValue);
              if (isResponsive) {
                // setActive("desktop");
                setValueTablet(resetValueTablet);
                setValueMobile(resetValueMobile);
              }
            }}
          />
        )}
        <input
          className="fly-range-input__field border w-fit  text-grigora-base  px-2 h-6 rounded-[6px] bg-editor-input-selected duration-300 focus-visible:border-gray-500 focus-visible:outline-none "
          type="number"
          min={min}
          max={max}
          step={step}
          value={
            active === "desktop"
              ? value
              : active === "tablet"
              ? valueTablet
              : valueMobile
          }
          onChange={(e) => {
            if (active === "desktop") {
              if (e.target.value > max) {
                onChange(max);
              } else if (e.target.value < min) {
                onChange(min);
              } else {
                onChange(e.target.value);
              }
            } else if (active === "tablet") {
              if (e.target.value > max) {
                setValueTablet(max);
              } else if (e.target.value < min) {
                setValueTablet(min);
              } else {
                setValueTablet(e.target.value);
              }
            } else {
              if (e.target.value > max) {
                setValueMobile(max);
              } else if (e.target.value < min) {
                setValueMobile(min);
              } else {
                setValueMobile(e.target.value);
              }
            }
          }}
        />
      </div>
    </div>
  );
}

export default NumberInput;
